import { memo } from 'react';
import { CampaignOptionLabel } from './CampaignOptionLabel';
import { jsx as _jsx } from "react/jsx-runtime";
function CampaignSelectedValueBase({
  option
}) {
  var _option$colorHex;
  return /*#__PURE__*/_jsx(CampaignOptionLabel, {
    text: option.text || option.buttonText || '',
    color: (_option$colorHex = option.colorHex) !== null && _option$colorHex !== void 0 ? _option$colorHex : undefined,
    truncate: true
  });
}
export const CampaignSelectedValue = /*#__PURE__*/memo(CampaignSelectedValueBase);